import { lazySubscribe, NotificationSubscription } from 'owa-notification';
import reminderNotificationAction from './actions/reminderNotificationAction';
import newMailNotificationAction from './actions/newMailNotificationAction';
import socialActivityNotificationAction from './actions/socialActivityNotificationAction';
import isConsumer from 'owa-session-store/lib/utils/isConsumer';
import NotificationType from 'owa-service/lib/contract/NotificationType';

let isSubscriptionInitialized = false;

export function subscribeToNotifications() {
    if (isSubscriptionInitialized) {
        return;
    }
    isSubscriptionInitialized = true;

    // subscribe and store the subscription objects

    lazySubscribe.importAndExecute(
        createSubscription('ReminderNotification', 'ReminderNotifications'),
        reminderNotificationAction
    );
    lazySubscribe.importAndExecute(
        createSubscription('NewMailNotification'),
        newMailNotificationAction
    );
    if (!isConsumer()) {
        lazySubscribe.importAndExecute(
            createSubscription('SocialActivityNotification'),
            socialActivityNotificationAction
        );
    }
}

function createSubscription(
    notificationType: NotificationType,
    id?: string
): NotificationSubscription {
    return {
        subscriptionId: id || notificationType,
        requiresExplicitSubscribe: true,
        subscriptionParameters: {
            NotificationType: notificationType,
        },
    };
}
